import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CodeableConcept, Utils } from 'src/app/shared/utils';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CommonsService {
  constructor(private readonly http: HttpClient, public translater: TranslateService) {}

  getUnitVolumes() {
    return this.http.get(environment.unitType);
  }

  getCustomUnits(units: string, measurementSystem?: string) {
    let params = {};

    if (units.includes('densityUnits')) {
      params = { params: { filter: `active:true AND coding.code:eq:"${measurementSystem.toUpperCase()}"` } };
    }
    return this.http.get(environment.enumerables + units, params);
  }

  organizationalChartAdministrativeAttributes() {
    return this.http.get(environment.organizationalChartAdministrativeAttribute).pipe(
      map(response => {
        return Utils.sortAToZ(this.translateText(response), 'textName');
      })
    );
  }

  organizationalChartAttributes() {
    return this.http.get(environment.organizationalChartAttribute).pipe(
      map(response => {
        return Utils.sortAToZ(this.translateText(response), 'textName');
      })
    );
  }

  languages() {
    return this.http.get(environment.languages).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  countries() {
    return this.http.get(environment.countries).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  gender() {
    return this.http.get(environment.gender).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  appointmentTypes() {
    return this.http.get(environment.appointmentTypes).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  civilStatus() {
    return this.http.get(environment.civilStatus).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  profession() {
    return this.http.get(environment.profession).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  nationality() {
    return this.http.get(environment.nationality).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  handDominance() {
    return this.http.get(environment.handDominance).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  identificationType(country?) {
    let url;
    if (country) {
      url = environment.identificationType + `?filter=coding.code:eq:${country.text}`;
    } else {
      url = environment.identificationType;
    }
    return this.http.get(url).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  // identificationTypeInternal() {
  //   return this.http.get(environment.identificationTypeInternal).pipe(
  //     map(result => {
  //       return result;
  //     })
  //   );
  // }

  payerTypes() {
    return this.http.get(environment.payerTypes).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  medicalIdentificationType() {
    return this.http.get(environment.medicalIdentificationType).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  specialties() {
    return this.http.get(environment.specialties).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  contactRelationships() {
    return this.http.get(environment.contactRelationships).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  systemSpecialties() {
    return this.http.get(environment.systemSpecialties).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  banks() {
    return this.http.get(environment.banks).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  qualifications() {
    return this.http.get(environment.qualifications).pipe(
      map(result => {
        return Utils.sortAToZ(this.translateText(result), 'textName');
      })
    );
  }

  typePerson() {
    return this.http.get(environment.typePerson).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  humanBodySystem() {
    return this.http.get(environment.hummanBodySystem).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  genericMedication() {
    return this.http.get(environment.genericMedication).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  medicationForm() {
    return this.http.get(environment.medicationForm).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  ingredientType() {
    return this.http.get(environment.ingredientType).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  unitMass(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get<any>(environment.unitMass + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  lengthUnit(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get<any>(environment.lengthUnit + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  weightUnit(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get<any>(environment.weightUnits + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  unitAceleration(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get<any>(environment.acelerationUnits + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  speedUnit(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get<any[]>(environment.speedUnits + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  presureUnit(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get(environment.pressureUnits + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  timeZone() {
    return this.http.get(environment.timeZone).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  currencieUnit(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get(environment.currenciesUnit + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  unitFrequency(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get(environment.frequencyUnits + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  unitTime(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get(environment.timeUnits + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  unitVolume(filter?: any) {
    if (filter === undefined) {
      filter = '';
    } else if (filter) {
      filter = filter;
    }
    return this.http.get<any>(environment.unitVolume + filter).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  unitType() {
    return this.http.get(environment.unitType).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  procedureStatus() {
    return this.http.get(environment.procedureState).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  practitionerRole() {
    return this.http.get(environment.practitionerRole).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }
  actPriorities() {
    return this.http.get(environment.actPriorities).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  relationFamilyShips() {
    return this.http.get(environment.familyRelationShip).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }
  diagnosisTypes() {
    return this.http.get(environment.diagnosisTypes).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }
  conditionVerificationStatus() {
    return this.http.get(environment.conditionVerificationStatus).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }
  conditions() {
    return this.http.get(environment.conditions).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  getEncounterDiets() {
    return this.http.get(environment.encounterDiets);
  }

  getEncounterSpecialCourtesies() {
    return this.http.get(environment.encounterSpecialCourtesies);
  }

  getEncounterAdmitSources() {
    return this.http.get(environment.encounterAdmitSources);
  }

  getUrgencyLevels() {
    return this.http.get(environment.urgencyLevels);
  }

  getEncounterDischarges() {
    return this.http.get(environment.encounterDischarges);
  }

  observationPerformers() {
    return this.http.get(environment.observationPerformers).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  observationInterpretations() {
    return this.http.get(environment.observationInterpretations).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  observationCategories() {
    return this.http.get(environment.observationCategories).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  immunizationOrigins() {
    return this.http.get(environment.immunizationOrigins).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }
  immunizationRoutes() {
    return this.http.get(environment.immunizationRoutes).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }
  underPoweredReason() {
    return this.http.get(environment.underPoweredReason).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  statusReason() {
    return this.http.get(environment.statusReason).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  compoundUnits() {
    return this.http.get(environment.compoundUnits).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  requestPriorities() {
    return this.http.get(environment.requestPriorities).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  medicationRequestCategories() {
    return this.http.get(environment.medicationRequestCategories).pipe(
      map(res => {
        return Utils.sortAToZ(this.translateText(res), 'textName');
      })
    );
  }

  getNegativeStatusReasonsList() {
    return this.http.get(environment.medicationAdminNotGivenCodes);
  }

  getReasonCodeList() {
    return this.http.get(environment.medicationAdminReasonCodes);
  }

  getStatusList() {
    return this.http.get(environment.medicationAdminStatus);
  }

  getRoutesList() {
    return this.http.get(environment.routeCodes);
  }

  getMethodsList() {
    return this.http.get(environment.medicationMethodCodes);
  }

  getCompoundUnits() {
    return this.http.get(environment.compoundUnits);
  }

  getNotifiationWays() {
    return this.http.get<any[]>(`${environment.enumerables}notificationWay`);
  }

  getConsultationTypes() {
    return this.http.get<any[]>(`${environment.enumerables}consultationType`);
  }
  translateText(list: any): any {
    list.forEach(item => {
      item.textName = this.getCodeableText(item);
      if (item.textName !== '' && item.textName !== undefined && item.textName !== null) {
        item.textName = item.textName.trim();
      }
    });
    return list;
  }
  getCodeableText(codeableConcept: CodeableConcept): string {
    return Utils.getCodeableConceptTranslationText(codeableConcept, this.translater.currentLang);
  }
  getTaskStatus() {
    return this.http.get<any[]>(`${environment.enumerables}taskStatus`);
  }
  getOperationalStatus() {
    return this.http.get<any[]>(environment.operationalStatus);
  }
}
